module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/4-34c68b49b3d430707d62ad0800ffeb23.jpg";